module.exports = "/lucky-balls/img/bigball/BigBall_019.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_019.png
// module id = 914
// module chunks = 0